import { FDCNotifications } from '../../../cimsPage/instances/fdc'
import { Notifications } from '../../common'

const { View, Edit } = Notifications({
  page: FDCNotifications,
  view: 'b2cfd73e-a2a0-4acb-86dc-4db7b316a710',
  edit: 'e23bac9b-3d1b-4254-93e6-f039e6d78079',
})

export const ViewFDCNotification = View
export const EditFDCNotification = Edit

export type FDCNotificationPermission =
  | typeof ViewFDCNotification
  | typeof EditFDCNotification
